var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-seperator",class:_vm.separatorClasses},[_vm._m(0),_c(_vm.type,{tag:"div"}),_vm._m(1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-placeholder before"},[_c('span',[_vm._v("↑")]),_vm._v(" The section before "),_c('span',[_vm._v("↑")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-placeholder after"},[_c('span',[_vm._v("↓")]),_vm._v(" The section after "),_c('span',[_vm._v("↓")])])
}]

export { render, staticRenderFns }